<template>
  <div class="panel-content">
    <question-description :currItem="currItem" :code="currItem.topic_type"></question-description>
    <div class="score-content" v-if="!isExamMode">
      {{ $t('evaluate_common_total_score') }}: <span :style="{ color: currItem.scores / currItem.score >= 0.8 ? '#09cba0' : '#fc5a5a' }">{{ isMarked == 2 ? currItem.scores : '-' }}</span
      >{{ `/${currItem.score}` }}
    </div>
    <div class="panel-content-ask" v-if="!showInput || !isExamMode">
      <div v-for="(item, index) in askList" :key="index">
        <span class="item-content">{{ item }}</span>
      </div>
    </div>
    <div class="panel-content-artical" v-if="!showInput || !isExamMode">
      <p v-for="(item, index) in currItem.screen_text" :key="index" v-if="index > 0">
        {{ item.content }}
      </p>
    </div>
    <div class="input-btn" v-if="!showInput">
      <span>{{ $t('hsk_abbreviation') }}</span>
      <count-down :time="count" @finish="clickShowInput" ref="countDownInput" :autoStart="false" format="mm:ss"> </count-down>
    </div>
    <div class="panel-content-input" v-if="showInput">
      <el-input v-if="isExamMode" :placeholder="$t('write_artical_title')" v-model="inputTitle" maxlength="20" @change="handlerSubmit" class="inputTitle" clearable> </el-input>
      <el-input v-if="isExamMode" type="textarea" :autosize="{ minRows: 8 }" :placeholder="$t('write_artical_content')" v-model="inputText" :maxlength="limitLength" @input="textInput" @change="handlerSubmit"> </el-input>
      <p v-if="isExamMode" class="limit">{{ wordLength }}/500</p>
      <div v-if="!isExamMode" class="show-result">
        <p class="title">{{ inputTitle }}</p>
        <p class="text" v-for="(item, index) in inputTextResult" :key="index">
          {{ item.trim() }}
        </p>
      </div>
      <p v-if="!isExamMode" class="limit-all">{{ computedSome }}/400</p>
    </div>
    <div class="panel-content-result" v-if="!isExamMode">
      <p class="orange">{{ $t('hsk_reference_answer') }}</p>
      <p class="correct-answer" v-for="(item, index) in analysisText" :key="index">
        {{ item }}
      </p>
    </div>
    <!-- <el-dialog
      :visible.sync="dialogVisible"
      width="300px"
      :show-close="false"
      top="30vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <p>{{ $t('hsk_determine_ans') }}</p>
      <p class="dialog_tips">{{ $t('hsk_determine_ans_tips') }}</p>
      <div slot="footer" class="dialog-footer">
        <span @click="dialogVisible = false">{{
          $t('button_common_cancel')
        }}</span>
        <span @click="clickShowInput">{{ $t('button_common_ok') }}</span>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import CountDown from '@/components/ui/count-down'
import bus from '@/utils/eventBus'
import QuestionDescription from '@/components/hsk/questionDescription'
import { mapState } from 'vuex'
import { getAllWordsLength } from '@/utils/utils'

export default {
  components: { CountDown, QuestionDescription },
  data() {
    return {
      inputText: '',
      inputTitle: '',
      askList: [],
      blankNum: 0,
      inputTextResult: [],
      count: 1,
      clickShowBtn: false,
      // dialogVisible: false,
    }
  },
  // provide: function () {
  //   return {
  //     abbreviationState: () => this.clickShowBtn,
  //   }
  // },
  computed: {
    language() {
      let local = localStorage.getItem('language')
      if (local == 'zh') {
        return 'cn'
      } else {
        return local
      }
    },
    computedSome() {
      let inputTextNumber = this.inputTextResult.length
        ? this.inputTextResult?.reduce(function (a, b) {
            return a + b
          })?.length
        : 0
      return this.inputTitle?.length + inputTextNumber
    },
    analysisText() {
      return this.currItem.evaluate.standard_answer[0].split('\n')
    },
    limitLength() {
      return 500 + this.blankNum
    },
    showInput() {
      return this.count <= 0 || this.clickShowBtn
    },
    wordLength() {
      return getAllWordsLength(this.inputText)
    },
    ...mapState('simulation', ['timeout']),
  },
  watch: {
    currItem: {
      handler(val) {
        console.log('val===', val)
        setTimeout(() => {
          this.count = this.leftTime - 2100000 //剩余时间减去35分钟
          this.clickShowBtn = !!this.writeIsBegin
          console.log('倒计时----', this.count)
          this.$nextTick(() => {
            if (this.count > 0) {
              this.$refs.countDownInput && this.$refs.countDownInput.reset()
              this.$refs.countDownInput && this.$refs.countDownInput.start()
            }
          })
          this.askList = val.screen_text[0].content.split('\n')
          if (val.answer) {
            this.inputTitle = val.answer.split('&&')[0]
            this.inputText = val.answer.split('&&')[1]
            if (!this.isExamMode) {
              this.inputTextResult = val.answer.split('&&')[1].split('\n') || []
            }
          }
        })
      },
      immediate: true,
    },
    '$store.state.simulation.timeout': function (newVal, oldVal) {
      if (newVal) {
        this.handlerSubmit()
      }
      console.log('Count changed from', oldVal, 'to', newVal)
    },
  },
  props: {
    //当前试题项
    currItem: {
      type: Object,
      required: true,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
    leftTime: {
      type: Number,
    },
    writeIsBegin: {
      type: [Number],
    },
    // 批改状态
    isMarked: {
      type: Number,
    },
  },
  methods: {
    //输入框监听
    textInput(e) {
      this.inputText = e
      let inputText = e.replace(/\ +/g, '')
      inputText = inputText.replace(/[\r\n]/g, '')
      this.blankNum = e.length - inputText.length
    },
    // titleInput(e) {
    //   this.titleInput = e
    // },
    //点击答题按钮
    clickShowInput() {
      // this.dialogVisible = false
      this.clickShowBtn = true
      bus.$emit('changeAbbreviationState', this.clickShowBtn)
    },
    handlerSubmit() {
      let key_words_must = this.currItem.evaluate.key_words_must ?? []
      let provide_words = this.currItem.evaluate.provide_words
      let mustWords = key_words_must.concat(provide_words)
      let answerLength = this.currItem.evaluate?.length?.split('-') ?? []
      answerLength = answerLength.map((item) => {
        item = parseInt(item)
        return item
      })
      let ansObj = {
        questionId: this.currItem.index,
        answer: this.inputTitle + '&&' + this.inputText,
        judge: 0,
        scores: null,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
        topic_type: this.currItem.topic_type,
        evaluate: {
          category: 'abbreviation',
          answer: this.inputTitle + '\n' + this.inputText,
          full_marks: this.currItem.score,
          reference_answer: JSON.stringify(this.currItem.evaluate.standard_answer),
          answer_length_range: JSON.stringify(answerLength),
          keywords: JSON.stringify(mustWords),
          unnecessary_keywords: JSON.stringify(this.currItem.evaluate.key_words_optional),
          original_text: this.currItem.evaluate.original_text,
          questionId: this.currItem.index,
        },
      }
      //选中后延时1ms再提交
      setTimeout(() => {
        this.$emit('saveRes', ansObj)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.panel-content {
  width: 100%;
  padding: 60px 29px 20px 29px;
  position: relative;
  .score-content {
    position: absolute;
    right: 23px;
    top: 16px;
  }
  .ques-area-des {
    position: absolute;
    left: 29px;
    top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #b5b5be;
    margin-top: 0px;
  }
  &-ask {
    margin: 20px 0px 25px 0px;
    padding: 15px;
    width: 100%;
    min-height: 157px;
    background: #f6f7fc;
    border-radius: 5px;
    line-height: 25px;
    .item-key {
      font-size: 14px;
      font-weight: 400;
      color: #9fa4af;
    }
    .item-content {
      font-size: 14px;
      font-weight: 500;
      color: #3e4651;
    }
  }
  &-artical {
    margin-bottom: 30px;
    p {
      text-indent: 2em;
      font-size: 14px;
      font-weight: 400;
      color: #393d46;
      line-height: 25px;
    }
  }
  &-input {
    margin-bottom: 40px;
    position: relative;
    .limit {
      position: absolute;
      bottom: 5px;
      right: 5px;

      font-size: 12px;
      font-weight: 400;
      color: #c6cad4;
    }
    .limit-all {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      margin-top: 10px;
      text-align: right;
    }
    .inputTitle {
      margin-bottom: 20px;
    }
    .show-result {
      .title {
        width: 100%;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        color: #393d46;
        margin-bottom: 20px;
      }
      .text {
        font-size: 14px;
        font-weight: 400;
        color: #3e4651;
        line-height: 25px;
        text-indent: 2em;
      }
    }
  }
  &-result {
    width: 100%;
    border-top: 1px dashed #e6eaef;
    padding: 30px 0px;
    .correct-answer {
      font-size: 14px;
      color: #545961;
      line-height: 25px;
      // text-indent: 2em;
    }
    .orange {
      font-size: 14px;
      font-weight: 500;
      color: #fc5a5a;
      margin-bottom: 20px;
    }
  }
  .input-btn {
    width: 294px;
    height: 60px;
    line-height: 60px;
    background: linear-gradient(to bottom, #faae56 0%, #faae56 100%);
    border-radius: 30px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 25px auto 0px auto;
    cursor: pointer;
  }
  .count-down {
    color: #ffffff;
    margin-left: 10px;
    font-size: 16px;
  }
  .dialog-footer {
    display: flex;
    align-items: center;
    border-top: 1px solid #f2f3f5;
    span {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 59px;
      cursor: pointer;
      &:first-child {
        border-right: 1px solid #f2f3f5;
      }
    }
  }
  .dialog_tips {
    font-size: 14px;
    margin-top: 10px;
    opacity: 0.8;
  }
}
</style>
